import React, { useEffect, useState } from 'react';
import { Slider } from '@meitu/saas-ui';
import IconFont from '@meitu/xdesign-icon-font';
import { useLocaleStore } from '@/i18n/index';
import { IPoint } from '@/version-types';
import './crop-image-scale.less';

interface ICropImageScaleProps {
    scale: number;
    setScale: (scale: number, isEnd?: boolean) => void;
    cancel: () => void;
    confirm: () => void;
    reset: () => void;
    isChange: boolean;
    adjustImage?: () => void;
    showAdjustImage?: boolean;
    cropScalePosition?: IPoint;
    isBackground?: boolean;
}

const CropImageScale: React.FC<ICropImageScaleProps> = ({
    scale,
    setScale,
    cancel,
    confirm,
    reset,
    isChange,
    showAdjustImage = false,
    adjustImage = () => {},
    cropScalePosition,
    isBackground = false,
}) => {
    const [opacity, setOpacity] = useState(0);
    const { $t } = useLocaleStore();

    const setScaleTip = (value: number = 100) => {
        let tip = value + '%';
        if (value >= 300) {
            tip = $t((v) => v.corpImage.tip);
        }
        return tip;
    };

    useEffect(() => {
        setTimeout(() => {
            setOpacity(1);
        }, 10);
    }, []);

    return (
        <div
            className="m-crop-img-scale"
            style={{
                left: cropScalePosition?.x,
                top: cropScalePosition?.y ?? 0 + (isBackground ? 10 : 0),
                transform: `translate(${cropScalePosition ? '0' : '-50%'}, 0)`,
                opacity,
            }}
        >
            <div className="m-crop-img-scale__left">
                <div className="m-crop-img-scale__title">{$t((v) => v.corpImage.scale)}</div>
                <Slider
                    className="m-crop-img-scale__slider"
                    defaultValue={scale * 100}
                    value={scale * 100}
                    min={100}
                    max={300}
                    tooltip={{ formatter: setScaleTip }}
                    onChange={(e) => setScale(e / 100)}
                    onAfterChange={(e) => setScale(e / 100, true)}
                />
            </div>
            <ul className="m-crop-img-scale__right">
                {/* 背景不展示适配图片 */}
                {!isBackground ? (
                    <li className={!showAdjustImage ? 'disable' : ''} onClick={() => adjustImage()}>
                        <span>{$t((v) => v.corpImage.adjustImage)}</span>
                    </li>
                ) : null}
                <li className={!isChange ? 'disable' : ''} onClick={() => reset()}>
                    <span>{$t((v) => v.corpImage.reset)}</span>
                </li>
                <li onClick={() => cancel()}>
                    <IconFont name="CrossBlack" fontSize={16}></IconFont>
                </li>
                <li className="active" onClick={() => confirm()}>
                    <IconFont name="CheckBlack" fontSize={16}></IconFont>
                </li>
            </ul>
        </div>
    );
};

export default CropImageScale;
